import { useState, FormEvent } from "react";
import ActionModal from "./ActionModal";

interface TurnLengthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (totalSeconds: number) => void;
  defaultMinutes?: number;
}

export default function TurnLengthModal({ isOpen, onClose, onSubmit, defaultMinutes = 10 }: TurnLengthModalProps) {
  const [minutes, setMinutes] = useState<number>(defaultMinutes);
  const [seconds, setSeconds] = useState<number>(0);
  const [error, setError] = useState<string>("");

  // Generate seconds options: 0, 5, 10, 15, ..., 55
  const secondsOptions = Array.from({ length: 12 }, (_, i) => i * 5);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (minutes < 0 || minutes > 60) {
      setError("Minutes must be between 0 and 60");
      return;
    }
    if (minutes === 0 && seconds === 0) {
      setError("Turn length must be greater than 0");
      return;
    }
    const totalSeconds = minutes * 60 + seconds;
    onSubmit(totalSeconds);
    setError("");
    onClose();
  };

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={onClose}
      title="Set Turn Length"
    >
      <form onSubmit={handleSubmit} style={{ padding: "1rem 0" }}>
        <div style={{ marginBottom: "1rem" }}>
          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: "bold", color: "#212529" }}>
            Turn Length:
          </label>
          <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
            <div style={{ flex: "1" }}>
              <input
                type="number"
                min="0"
                max="60"
                value={minutes}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  if (!isNaN(value)) {
                    setMinutes(value);
                    setError("");
                  }
                }}
                style={{
                  width: "90%",
                  padding: "0.5rem",
                  fontSize: "1rem",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                }}
                autoFocus
              />
              <div style={{ fontSize: "0.75rem", color: "#6c757d", marginTop: "0.25rem" }}>Minutes</div>
            </div>
            <div style={{ flex: "0 0 120px" }}>
              <select
                value={seconds}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 0);
                  setSeconds(value);
                  setError("");
                }}
                style={{
                  width: "100%",
                  padding: "0.5rem",
                  fontSize: "1rem",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                }}
              >
                {secondsOptions.map((sec) => (
                  <option key={sec} value={sec}>
                    {sec}s
                  </option>
                ))}
              </select>
              <div style={{ fontSize: "0.75rem", color: "#6c757d", marginTop: "0.25rem" }}>Seconds</div>
            </div>
          </div>
          {error && (
            <div style={{ color: "#dc3545", fontSize: "0.875rem", marginTop: "0.5rem" }}>
              {error}
            </div>
          )}
        </div>
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "0.5rem 1rem",
              cursor: "pointer",
              backgroundColor: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "4px",
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            style={{
              padding: "0.5rem 1rem",
              cursor: "pointer",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
            }}
          >
            Start Timer
          </button>
        </div>
      </form>
    </ActionModal>
  );
}

